import { useSrpContext } from '@/src/contexts'
import { useTranslations } from 'next-intl'

import EditorialMeta from './editorialMeta'

const EditorialMetaWrapper = () => {
    const {
        SEOSrpData: { sections }
    } = useSrpContext()
    const t = useTranslations('common.routeSeoContent')

    const editorialMeta = sections?.editorialMeta
    if (!editorialMeta) return null

    const lines: string[] = []

    if (editorialMeta.fareDataSource) {
        lines.push(`${t('informationSource')}: ${editorialMeta.fareDataSource}`)
    }
    if (editorialMeta.methodology) {
        lines.push(editorialMeta.methodology)
    }
    if (editorialMeta.reviewedBy) {
        const updatedAt = editorialMeta.fareUpdatedAt
            ? editorialMeta.fareUpdatedAt.split('T')[0]
            : ''
        const suffix = updatedAt ? `. ${t('lastUpdated')}: ${updatedAt}` : ''
        lines.push(`${editorialMeta.reviewedBy}${suffix}`)
    }

    if (lines.length === 0) return null

    return <EditorialMeta lines={lines} />
}

export default EditorialMetaWrapper
